import { ApolloClient, ApolloLink, InMemoryCache } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { onError } from '@apollo/client/link/error';
import { createUploadLink } from 'apollo-upload-client';
import { getApiKeyFromUrl, getUserScopeFromCookie } from '@common/utils/auth/authUtils';
import appConfig from '@configs/app-config';

const uploadFilesLink = createUploadLink({
  uri: appConfig.bffApiUrl,
});

const authLink = setContext((_, { headers }) => {
  const userScope = getUserScopeFromCookie();
  const apiKeyFromUrl = getApiKeyFromUrl();
  const apiKey = userScope?.a1_app_key || apiKeyFromUrl || '';

  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      apiKey: apiKey ? apiKey : '',
      userScope: userScope ? JSON.stringify(userScope) : '',
    },
  };
});

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (networkError) {
    console.error(`[Network error]: ${networkError}`);
  }

  if (graphQLErrors) {
    graphQLErrors.forEach(({ message, locations, path }) =>
      console.error(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`)
    );
  }
});

const apolloClientConfig = new ApolloClient({
  cache: new InMemoryCache(),
  link: ApolloLink.from([errorLink, authLink, uploadFilesLink]),
});

export default apolloClientConfig;
